export default function(message) {
    console.warn(`[Bootstrap-Vue warn]: ${message}`);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/basicos/libs/warn.js